import {
  ItemPageAdminSectionPluginModel,
  ItemPageAdminSectionDto,
} from '@marketplace-web/domain/item-page-data'

export const getItemPageAdminSectionPluginModel = (
  pluginData: ItemPageAdminSectionDto,
): ItemPageAdminSectionPluginModel => ({
  itemId: pluginData.item_id,
})
